<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="popup_box ungame_balance_popup modal_cont" id="">
        <img :src="closeIconSrc" class="btn_close">
        <h1>{{ getTranslations.home_modal_unlocked_zero_you_do_not }}</h1>
        <h6>{{ getTranslations.home_modal_unlocked_zero_play }}</h6>
        <img :src="prizeSpinSrc" class="ungame_bal_img">
        <p>{{ getTranslations.home_modal_unlocked_zero_unlock_more }}</p>
        <button type="" @click="toBundlesPage">{{ getTranslations.home_modal_unlocked_zero_unlock_button }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'unlocked-games-zero-balance-modal',
  mixins: [SkinMixin],
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    prizeSpinSrc() {
      return this.$_skinImage({ fileName: 'popups/prize-spin.svg', skins: [100] });
    },
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/unlockedgames/UnlockedGamesZeroBalanceModal.vue